import React from 'react';
import WName, {WArticle} from '../../WName';
import PL from '../../problems/ProblemLink';
import QL from '../../faq/QuestionLink';
import AL from '../../angles/AngleLink';
import NW from '../../neologisms/NewWord';
import OML from '../../ormaybe/OrMaybeLink';
import LRL from '../LongReadLink';
import {E1, E2} from '../../common';

// ‘’ … –

// In the 2020's it's the most dangerous thing: dare to imagine.
export const kujifanya = {
  name: "kujifanya",
  prelude: <span>
    Ten thousand Products<sup>™</sup>? Your <NW>agency</NW> to <i>choose</i> between <QL name="languages">万种</QL> (wàn zhǒng: 10,000) <PL name="reactivity.">pre-defined</PL> Options<sup>™</sup>? No. Consumer ‘choice’ ≠ <QL>imagination</QL>.
  </span>,
  header: <span>
    Usiogope kujifanya: dare to imagine.
  </span>,
  outside: <span>
    In <QL name="languages">French</QL>: have the <NW>savoir-vouloir</NW>.
  </span>,
  preview: <div className="long-read-preview">
    <p>It’s a maxim from the stories about <QL>Pratty Africa</QL>.</p>
    <ul>
      <li><i>Usiogope</i> is <QL name="languages">Swahili</QL> for, ‘Do not be afraid,’ – because <PL>fear</PL> is the <QL>consciousness</QL>-killer.</li>
      <li><i>Kujifanya</i> means to ‘pretend’… but not necesarily in the sense of <i>lying</i> (for which the Spanish word ‘fingir’ is often employed; if there’s a reason it’s <i><QL name="languages">Spanish</QL></i>, that may not actually <OML>matter</OML>), but in the sense of daring to pretend that something that is <OML name="harmony">not yet true</OML> may be <QL name="future">one day</QL>.</li>
    </ul>
    <p>Dare to imagine and – <QL name="languages.segun">según</QL> the <AL>bullet points</AL> – <QL name="salvation">creativity will be our salvation</QL>.</p>
  </div>,
  text: <div className="long-read-text">
    <p>So it’s <AL name="notnew.p.quine">translated</AL> – to <PL>English</PL> – as ‘dare to imagine’. At first (hardly <i>thinking</i>) you might suppose that there’s a huge difference. ‘Don’t’ – even in ‘don’t fear’ – is just <i>not</i> doing something (cf. <NW>APE</NW>). ‘Dare’ implies <i><NW>agency</NW></i>.</p>
    <p>But it requires <LRL>understanding</LRL> the notion of <i><PL>fear</PL></i> – which is the <QL>consciousness</QL>-killer. Fear implies inaction: <i>not</i> acting, and just <PL name="flow">going with the flow</PL> of <PL>reactivity</PL> and the <PL>comfort</PL> of <i>not</i> taking <i><LRL>accountability</LRL></i> (cf. the <AL name="handicap">hominid</AL>-appeal of a <NW>ziggurat</NW>, nd the <NW>FOE</NW>).</p>
    <p>Therefore (∴ – <QL name="silly">bowling-ball symbol</QL>), both are demands to <i><AL name="sleeping">wake up</AL></i>. Both are demands for <NW>agency</NW> over <PL>reactivity</PL>. To – in short – <PL name="comprehensive">unfetter</PL> the <LRL>imagination</LRL>.</p>
    <p>To the <NW>CMEs</NW>, this is anathema: the most Unsafe<sup>®</sup> thing there is. To a <WName ist />? It is <i><AL>freedom</AL></i>.</p>
  </div>,
};
